export function QuickLauncherIcons({
  icon,
  style,
  width = 'var(--ng-s-16)',
  height = 'var(--ng-s-16)',
  filter = 'hue-rotate(174deg) saturate(18%) brightness(28%)'
}) {
  return (
    <img
      style={{ ...style, filter, width, height }}
      src={`/images/launcherIcons/${icon}.svg`}
      alt="icon"
    />
  );
}
